export default "__VITE_ASSET__370fd2cc__"